/**
 * @module app.shared
 */
import { autoinject } from "aurelia-framework";
import { Api } from 'app/shared/lib/api/api';
import { EnvironmentService } from 'app/shared/services/environment-service';

interface ILockService {
    lock(): Promise<void>;
    unlock(password: string): Promise<boolean>;
}

@autoinject
export class LockoutService implements ILockService {

    constructor(private readonly api: Api, private readonly env: EnvironmentService) { }

    public async lock(): Promise<void> {
        await this.api.lockSession();
    }

    public async unlock(password: string): Promise<boolean> {
        if(!this.env.user.isLoggedIn) { return false; }
        try {
            await this.api.unlockSession(this.env.user.loginName, password);
            return true;
        }
        catch {
            return false;
        }
    }

}
